var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 13.75H11.25L15.3625 9.63751C15.4797 9.52131 15.5727 9.38306 15.6361 9.23074C15.6996 9.07841 15.7322 8.91503 15.7322 8.75001C15.7322 8.585 15.6996 8.42162 15.6361 8.26929C15.5727 8.11697 15.4797 7.97872 15.3625 7.86251C15.1283 7.6297 14.8115 7.49902 14.4813 7.49902C14.151 7.49902 13.8342 7.6297 13.6 7.86251L8.2375 13.2375C7.76802 13.7042 7.50279 14.338 7.5 15C7.50608 15.6576 7.77106 16.2864 8.2375 16.75L13.6 22.125C13.7165 22.2407 13.8547 22.3324 14.0067 22.3947C14.1587 22.457 14.3214 22.4888 14.4857 22.4882C14.6499 22.4876 14.8124 22.4547 14.964 22.3913C15.1155 22.3279 15.253 22.2353 15.3688 22.1188C15.4845 22.0022 15.5761 21.864 15.6384 21.7121C15.7008 21.5601 15.7325 21.3973 15.7319 21.2331C15.7314 21.0688 15.6984 20.9063 15.6351 20.7548C15.5717 20.6033 15.479 20.4657 15.3625 20.35L11.25 16.25H23.75C24.0815 16.25 24.3995 16.1183 24.6339 15.8839C24.8683 15.6495 25 15.3315 25 15C25 14.6685 24.8683 14.3506 24.6339 14.1161C24.3995 13.8817 24.0815 13.75 23.75 13.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallLeft);
export default __webpack_public_path__ + "static/media/arrow-small-left.dfbf558611b87f8884d5688a9ae38617.svg";
export { ForwardRef as ReactComponent };